import { GzIncrementInputWebComponent } from './component/GzIncrementInputWebComponent';

export { GzIncrementInputWebComponent };
